import UserStoreModule from '../../../user/store/module';

export const ENABLED_DISCOUNT_CODES_LIST: number[] = [];

export default function isDiscountCodesList(): boolean {
  const storeId = UserStoreModule?.data?.store?.id ?? 0;

  return ENABLED_DISCOUNT_CODES_LIST.includes(storeId);
}
